import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/index.css';
import { isUiDemoRequested, seedFakeAuth, startUiDemoMocks } from '@/mocks/ui-demo';

async function bootstrap() {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error(
      'Root element not found. Make sure there is a <div id="root"> in your index.html.',
    );
  }

  if (isUiDemoRequested()) {
    seedFakeAuth();
    await startUiDemoMocks();
  }

  // Dynamic import: App (and the Zustand auth store it pulls in) must not be
  // evaluated until after the localStorage seed above - a static import
  // would run the store's `persist` read at module-load time, before this
  // function's own body executes.
  const { App } = await import('@/app/App');

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

bootstrap();
